import Vue from 'vue';

import {
    postTelNumber,
    postTelNumberV2,
    getResponeStatus,
    fetchMapDataLastModified,
} from '../utils/services';

import { fetchMoviesByCinemaId } from '../utils/services/cinemas-service';

import * as services from '../utils/services';
import {deepSeal} from "@/utils/helpers/common";
import {isMobile} from "mobile-device-detect";

export * from "./statistics-actions";

export const fetchMapData = async ({ commit, dispatch, getters, state }, mapId = null) =>
{
    let dataSourceType = process.env.VUE_APP_DATA_SOURCE || 'CDN';

    if(!state.dataSourceType){
        if(document.location.href.includes('dataSource=CDN')) dataSourceType = 'CDN';
        if(document.location.href.includes('dataSource=API')) dataSourceType = 'API';
        if(document.location.href.includes('dataSource=LOCALHOST')) dataSourceType = 'LOCALHOST';
        commit('setDataSource', dataSourceType);
    }
    else{
        dataSourceType = state.dataSourceType;
    }

    commit('setIsMapDataUpdateNeeded', false);
    const response = await services[`fetchMapDataFrom${dataSourceType}`](mapId);
    let data = response.data;

    if(dataSourceType === 'LOCALHOST'){
        const baseUrl =  window.location.origin + window.location.pathname.replace('/index.html','');
        data = JSON.parse(JSON.stringify(data).replaceAll('{{##baseUrl##}}', baseUrl));
    }

    await dispatch('pushDataToState', data);

    // in case if data loaded from CDN save last modified date
    if(state.dataSourceType === 'CDN' && response && response.headers && response.headers['last-modified']){
        commit('setLastModified', Date.parse(response.headers['last-modified']));
        commit('setLastModifiedCheckedAt', Date.now());
    }
    dispatch('checkIsEmbedForbidden');

    commit('setAppLoaded', true);
    return Promise.resolve(response.data);
};

export const checkIsEmbedForbidden = ({ commit, getters }, newLocale) => {
    if(window.parent !== window.self){
        const ao = window.location.ancestorOrigins;
        const url = ao && ao.length && ao[ao.length - 1] || document.referrer;
        const allowedOrigins = getters.getMapConfigProp('features.protection.allowed_origins', []);
        const isForbidden = allowedOrigins.length ? !allowedOrigins.some(or => url.includes(or)) : false;

        if(isForbidden){
            commit('setIsEmbedForbidden', true);
        }
    }

};

export const changeLocale = ({ commit, getters }, newLocale) => {
    if( getters.getActiveLocale !== newLocale) {
        // UX hack: allow lang dropdown to close before applying major recalculations
        setTimeout(() => {
            commit('setActiveLocale', newLocale);
            Vue.i18n.set(newLocale);
        },10);
    }
};
export const pushDataToState = ({ commit, dispatch, getters , state}, incomingData) => {
    const data = deepSeal(incomingData);
    commit('setMap', data.map);
    commit('setCustomer', data.customer);
    commit('pushMapUnits', data.units);
    commit('pushMapModels', data.models);
    commit('pushCategories', data.categories);
    // commit('pushUnfilteredMapObjects', data.objects);
    commit('setActiveLocale', data.map.meta.language);
    commit('setDefaultLocale', data.map.meta.language);
    commit('setTerminalsList', data.terminals);

    let terminal = null;

    // set terminal object ID by terminal code
    if(state.terminalCode && data.terminals){

        const intcode = Number(state.terminalCode);

        if( intcode ){
            terminal = data.objects.find( t => t.id === intcode);
            terminal && commit('setTerminalId', terminal.id);
        }
        else {
            terminal = data.terminals.find(t => t.code === state.terminalCode);
            terminal && commit('setTerminalId', parseInt(terminal.unit,10));
        }

        if(!terminal){
            const msg = data.map.name + ': Terminal ' + state.terminalCode + ' not found in data. Can\'t Load App! If terminal was recently added publish & generate zip again';
            console.error(msg);
            throw new Error(msg);
        }

    }
    commit('setActiveMapTheme', defineThemes(getters, data.objects));
    commit('pushMapObjects', {objects: data.objects, appThemes: state.activeMapTheme});

    if(terminal && terminal.type == 'poster')
        commit('setObjectIndexes', getters.getObjectsWithNumbers);

    const translations = {};

    data.translations.forEach(item => {
        Object.keys(item.meta).forEach(el => {
            if(item.meta[el]){
                if(!translations[el])
                    translations[el] = {};

                translations[el][item.name] = item.meta[el]
            }

        })
    });

    if( _.has(data,'map.meta.languages') ) {
        data.map.meta.languages.forEach(el => {
            Vue.i18n.add(el, translations[el]);
        });
    }

    Vue.i18n.set(data.map.meta.language);
    Vue.i18n.fallback('en');
};

export const setAppLoaded = ({ commit }, value) => {
    commit('setAppLoaded', value)
};

export const sendSms = ({getters}, data) => {
    return postTelNumber({ ...data, lang: getters.getActiveLocale})
};

export const sendSmsV2 = ({getters}, data) => {
    return postTelNumberV2({ ...data, lang: getters.getActiveLocale})
};

export const generateSessionId = ({commit}) => {
    commit('setSessionId', new Date().getTime())
}

export const changeLocaleAtStart = ({commit,state}) => {

    return;

    // This function check language setting device or browser and change locale after
    const langProp = document.location.href.toString().match(/[&?]lang=(\w{2,3})/);

    let language =
        (langProp && langProp[1]) ||
        window?.navigator?.language ||
        window?.navigator?.systemLanguage ||
        window?.navigator?.userLanguage ||
        "en";

    language = language.substr(0, 2)
    if (state.map.meta.languages.includes(language)) {
        commit('setActiveLocale', language)
        Vue.i18n.set(language)
    }
}

export const checkDoesMapDataUpdateNeeded = async ({dispatch, commit, state}, mapId) => {
    const lastModified = await fetchMapDataLastModified(mapId);
    const isUpdateNeeded = state.lastModified !== lastModified;
    commit('setIsMapDataUpdateNeeded', isUpdateNeeded);
    commit('setLastModifiedCheckedAt', Date.now());
    return isUpdateNeeded;
};

export const checkScreensaverUrl = async ({commit}, screensaverUrl) => {
    return 200 === +await getResponeStatus(screensaverUrl);
};

export const getMoviesList = async ({commit, state}, {cinemaId, cinemaProvider}) => {
    try {
        const {data} = await fetchMoviesByCinemaId(cinemaId, cinemaProvider);
        if(data && data.length) {
            commit('setMoviesList', data)
            commit('setLastMoviesUpdate')
        };
    } catch (error) {
        console.warn(error);
    } finally {
        checkMovieActual(commit, state)
    }
};

export const moviesListInterval = ({commit, dispatch, getters, state}) => {
    if(state.moviesListTimeout) {
        clearInterval(state.moviesListTimeout)
        commit('setMoviesListTimeout', null)
    }
    if(isOnline()) {
        const kinoServiceId = getters.getServicesCategoriesRootLevel.filter(({meta}) => meta.is_kino)[0]?.id;
        const kinoService = getters.getObjectsByCategory(kinoServiceId)[0];

        if(kinoServiceId) {
            const timerId = setInterval(() => { 
                dispatch('getMoviesList', {
                    cinemaId: kinoService?.meta.cinema_id || kinoService?.meta.cinemaId, 
                    cinemaProvider: kinoService?.meta.cinema_provider
                }) 
            }, 900000)

            commit('setMoviesListTimeout', timerId)

            dispatch('getMoviesList', {
                cinemaId: kinoService?.meta.cinema_id || kinoService?.meta.cinemaId, 
                cinemaProvider: kinoService?.meta.cinema_provider
            })
        }
    }
};

function isOnline(){
    return window.navigator.onLine;
}

/**
 * If something wrong with kino-API, and we don't take the new schedule during 15h
 * we clear kino data!
 */
function checkMovieActual (commit, state) {
    const now = +new Date;
    const lastUpdateTime = now - state.lastMoviesUpdate;
    if(lastUpdateTime > 54000000) {
        commit('setMoviesList', [])
        commit('setLastMoviesUpdate')
    }
}
function defineThemes(getters, objects) {
    //Query Themes Block
    const queryTheme = getQueryParams('theme');
    const queryThemesBlock = queryTheme ? [queryTheme] : [];

    //Env Themes Block
    const envTheme = process.env.VUE_APP_THEME;
    const envThemesBlock = getThemeVariations(envTheme, getters);

    //Terminal Themes Block
    const terminal = objects.find(o => o.id == getters.getTerminalId)
    const terminalTheme = terminal?.meta['default_theme'];
    const terminalThemesBlock = getThemeVariations(terminalTheme, getters);

    //App Themes Block
    const deviceType = getters.getDeviceType;
    const appTheme = getters.getMap.meta[`theme_default_${deviceType}`] || getters.getBaseAppThemeName;
    const appThemesBlock = getThemeVariations(appTheme, getters);

    const themesTree = [
        ...queryThemesBlock,
        ...envThemesBlock,
        ...terminalThemesBlock,
        ...appThemesBlock,
        'default',
    ];
    console.log('themesTree: ', themesTree);

    return themesTree;
}

function getThemeVariations(theme, getters){
    if(!theme) {
        return [];
    }

    const deviceFamilySuffix = getters.getDeviceFamilyThemeSuffix;
    const mobileSuffix = isMobile && '--mobile' || '';
    const embedSuffix = getters.isEmbed && '--embed' || '';

    return [
        // make array values unique
        ...new Set([
            theme + deviceFamilySuffix + mobileSuffix + embedSuffix,
            theme + deviceFamilySuffix + mobileSuffix,
            theme + deviceFamilySuffix + embedSuffix,
            theme + deviceFamilySuffix,

            theme + mobileSuffix + embedSuffix,
            theme + mobileSuffix,
            theme + embedSuffix,

            theme
        ])
    ]
}

function getQueryParams(paramName) {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    if (queryParams.has(paramName)) {
        return queryParams.get(paramName);
    } else {
        return false;
    }
}
